import i18n from "@/i18n";
import storeCache from "@/js/storeCache";
import { roleInCompany } from "@/js/utils";
import router from "@/router";
import { useCompanyStore } from "@/stores/company.store";
import { useUserStore } from "@/stores/user.store";

const hasActiveSubscription = () => {
  const user = storeCache.get("currentUser");
  if (!user || !user.subscriptionEndDate || user.subscriptionEndDate === null) {
    return false;
  }
  const subscriptionEndDate = new Date(user.subscriptionEndDate);
  const currentDate = new Date();
  return subscriptionEndDate > currentDate;
};

export const handleVerificationGuard = async (emitter: any) => {
  //turned sub guard off
  return true;

  const company = useCompanyStore();
  const userStore = useUserStore();
  const companyId = storeCache.get("currentCompany")?.id;
  const updatedCompany = await company.fetchOneCompany(companyId);
  await userStore.fetchCurrentUser();
  const user = storeCache.get("currentUser");
  // if (updatedCompany?.missingDocuments?.length > 0) {
  //   router.push("/add-documents");
  //   emitter.emit("showPopup", {
  //     message: i18n.global.t("profile.you_have_unadded_documents"),
  //     type: "error",
  //     buttonText: i18n.global.t("generals.go"),
  //   });
  //   return false;
  // }
  // if (!updatedCompany?.documentsVerified) {
  //   router.push("/dokumenty");
  //   emitter.emit("showPopup", {
  //     message: i18n.global.t("profile.you_have_unverified_documents"),
  //     type: "error",
  //     buttonText: i18n.global.t("generals.go"),
  //   });
  //   return false;
  // }
  if (roleInCompany() === "OWNER") {
    if (!hasActiveSubscription()) {
      router.push("/moj-portfel-subskrypcje");
      emitter.emit("showPopup", { message: i18n.global.t("profile.you_need_subscription"), type: "error", buttonText: i18n.global.t("generals.go") });
      return false;
    }
  }
  // if (user.status === "WAITING_FOR_ACCEPTANCE") {
  //   router.push("/dashboard");
  //   emitter.emit("showPopup", { message: i18n.global.t("profile.waiting_for_acceptance"), type: "error", buttonText: i18n.global.t("generals.go") });
  //   return false;
  // }
  // if (updatedCompany.status === "WAITING_FOR_ACCEPTANCE") {
  //   router.push("/dashboard");
  //   emitter.emit("showPopup", { message: i18n.global.t("profile.waiting_for_acceptance"), type: "error", buttonText: i18n.global.t("generals.go") });
  //   return false;
  // }

  return true;
};
